var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "formulate-input-element" }, [
    !_vm.context
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v(" Contexto não encontrado! "),
        ])
      : _c(
          "div",
          [
            _c("div", { staticClass: "editor-controls" }, [
              _c(
                "button",
                {
                  staticClass: "toggle-button",
                  class: { active: _vm.isCodeMode },
                  attrs: { type: "button", disabled: _vm.context.disabled },
                  on: { click: _vm.toggleMode },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.isCodeMode ? "Modo Visual" : "Modo Código") +
                      " "
                  ),
                ]
              ),
              _vm.isCodeMode
                ? _c(
                    "button",
                    {
                      staticClass: "format-button",
                      attrs: {
                        type: "button",
                        disabled: _vm.context.disabled,
                        title: "Formatar HTML",
                      },
                      on: { click: _vm.formatCode },
                    },
                    [_vm._v(" Formatar ")]
                  )
                : _vm._e(),
            ]),
            !_vm.isCodeMode
              ? _c("vue-editor", {
                  attrs: {
                    placeholder:
                      _vm.context.placeholder || "Digite o conteúdo...",
                    "editor-toolbar": _vm.editorToolbar,
                    disabled: _vm.context.disabled,
                  },
                  on: {
                    blur: function ($event) {
                      _vm.context.blurHandler || _vm.blur
                    },
                    focus: function ($event) {
                      _vm.context.focusHandler || _vm.focus
                    },
                  },
                  model: {
                    value: _vm.context.model,
                    callback: function ($$v) {
                      _vm.$set(_vm.context, "model", $$v)
                    },
                    expression: "context.model",
                  },
                })
              : _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.context.model,
                      expression: "context.model",
                    },
                  ],
                  staticClass: "code-textarea",
                  attrs: {
                    placeholder: _vm.context.placeholder || "Digite o HTML...",
                    disabled: _vm.context.disabled,
                  },
                  domProps: { value: _vm.context.model },
                  on: {
                    blur: function ($event) {
                      _vm.context.blurHandler || _vm.blur
                    },
                    focus: function ($event) {
                      _vm.context.focusHandler || _vm.focus
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.context, "model", $event.target.value)
                    },
                  },
                }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }